import { markRaw } from 'vue';
import { AlertTriangle, CheckCircle2, CircleHelp, Clock3, Info, PauseCircle, Sparkles } from 'lucide-vue-next';
import type { ProjectNoticeIcon } from '~/types/models';

export const PROJECT_NOTICE_ICON_OPTIONS = [
    { value: 'alert-triangle', label: 'Warning', component: markRaw(AlertTriangle) },
    { value: 'info', label: 'Info', component: markRaw(Info) },
    { value: 'pause-circle', label: 'On hold', component: markRaw(PauseCircle) },
    { value: 'clock-3', label: 'Waiting', component: markRaw(Clock3) },
    { value: 'circle-help', label: 'Needs input', component: markRaw(CircleHelp) },
    { value: 'sparkles', label: 'Update', component: markRaw(Sparkles) },
    { value: 'check-circle-2', label: 'Resolved', component: markRaw(CheckCircle2) },
] as const satisfies ReadonlyArray<{
    value: ProjectNoticeIcon,
    label: string,
    component: unknown,
}>;

export function getProjectNoticeIconComponent(icon?: ProjectNoticeIcon) {
    return PROJECT_NOTICE_ICON_OPTIONS.find(option => option.value === icon)?.component || AlertTriangle;
}

export function getProjectNoticeIconLabel(icon?: ProjectNoticeIcon) {
    return PROJECT_NOTICE_ICON_OPTIONS.find(option => option.value === icon)?.label || 'Warning';
}
